<div class="xp-chart__box" [style.height]="height()">
	<canvas #canvas role="img" [style.height]="height()"></canvas>
</div>
